export default __webpack_public_path__ + "assets/2250fcc30f77b4315a71ce9a58116a34.svg";